const ESTADO_INICIAL = 
    { 
        laudo : "",
        modalAberto: false,
        liberacaoParcialHabilitada: false  
    }
    
const modalLiberacaoParcialReducer =  (state = ESTADO_INICIAL, action) => {    
    switch(action.type) {
        case 'CONFIRMAR_LIBERACAO_PARCIAL':
            return { ...state, modalAberto: false, laudo: action.payload.laudo }
        case  'FECHAR_MODAL':            
            return { ...state, modalAberto: action.payload.modalAberto , laudo: action.payload.laudo  }
        case  'OBTER_CONFIGURACAO':            
            return { ...state, liberacaoParcialHabilitada: action.payload.liberacaoParcialHabilitada   }
        default:
            return state
    }
}

export default modalLiberacaoParcialReducer;


// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_parcial/store/liberacao.reducer.js